import { useEffect, useState } from 'react'
import './map-container.css'

let cellWidth
let cellHeight
let ctx
let map

// focntions de localisation et de dessin
function getAbscisse(tdId) {
  return (tdId.slice(1) - 1) * cellWidth
}

function getOrdonnee(tdID) {
  return 'ABCDEFGHIJKLMNO'.indexOf(tdID[0]) * cellHeight
}

function canvas_arrow(context, fromx, fromy, tox, toy) {
  var headlen = 10; // length of head in pixels
  var dx = tox - fromx;
  var dy = toy - fromy;
  var angle = Math.atan2(dy, dx);
  context.moveTo(fromx, fromy);
  context.lineTo(tox, toy);
  context.lineTo(tox - headlen * Math.cos(angle - Math.PI / 6), toy - headlen * Math.sin(angle - Math.PI / 6));
  context.moveTo(tox, toy);
  context.lineTo(tox - headlen * Math.cos(angle + Math.PI / 6), toy - headlen * Math.sin(angle + Math.PI / 6));
}




export default function CodeContainer(props) {

  // LOGIC
  const mapWay = props.mapWay
  const startX = getAbscisse(props.start)
  const startY = getOrdonnee(props.start)
  console.log(`map : ${mapWay}`)
  const selected = props.selected
  const selectedCell = props.selectedCell

  if (mapWay.length != 0) {
    // Ajout de la classe selectd cell 
    mapWay.forEach(id => {
      document.querySelector(`#${id}`).classList.add("selected-cell")
    })
    // Creation du canvas
    let canvas = document.createElement("canvas")
    ctx = canvas.getContext("2d")
    map = document.querySelector("#grid")
    canvas.style.position = "absolute"
    canvas.width = map.offsetWidth
    canvas.height = map.offsetHeight
    canvas.style.top = "0"
    canvas.style.left = "0"
    map.appendChild(canvas)
  }
  else{
    try{
      let canvas = document.querySelector("canvas")
      document.querySelectorAll(".selected-cell").forEach(e =>{e.classList.remove("selected-cell")})
      canvas.remove()}
    catch (e){console.log(e)}
  }


  useEffect(() => {
    // currentExoActivate()
    const cells = document.querySelectorAll(".cell")
    cells.forEach((cell) => {
      // Gestion de la hauteur 
      cell.style.height = `${50}px`;
      cell.style.width = `${50}px`;
    })
    cellWidth = document.querySelector("#A1").offsetWidth
    cellHeight = document.querySelector("#A1").offsetHeight
  }, [])

  useEffect(() => {
    if (mapWay.length != 0) {
      const way = [props.start, ...mapWay]
      ctx.clearRect(0, 0,600, 600);
      for (let i = 0; i < way.length - 1; i++) {
        console.log(way[i])
        let fromX = getAbscisse(way[i])
        let fromY = getOrdonnee(way[i]) + cellHeight / 2
        let toX = getAbscisse(way[i + 1])
        let toY = getOrdonnee(way[i + 1]) + cellHeight / 2
        console.log(fromX)
        console.log(toX)
        if (toX < fromX) {
          toX = toX + cellWidth + 5
          fromX = fromX - 5
        }
        else if (toX > fromX) {
          fromX = fromX + cellWidth + 5
          toX = toX - 5
        }
        else {
          fromX = fromX + cellWidth / 2
          toX = toX + cellWidth / 2
          if (toY < fromY) {
            toY = toY + cellHeight/2 + 5
            fromY = fromY - cellHeight/2 - 5
          }
          else if (toY > fromY){
            toY = toY - cellHeight/2 - 5
            fromY = fromY + cellHeight/2 + 5
          }
        }

        ctx.beginPath();
        canvas_arrow(ctx, fromX, fromY, toX, toY)

        ctx.stroke();
      }

    }
 
  },
    [mapWay])

  // RENDER
  return (
    <div className="basis-2/3   max-h-screen  pt-10">
      <div className="bg-white dark:bg-slate-900   rounded-lg px-6 py-8 ring-1 ring-slate-900/5 shadow-xl mr-10">
        <div onClick={()=>{props.setOpen(true)}}>
          <span className="inline-flex items-center justify-center p-2 bg-indigo-500 rounded-md shadow-lg">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z" />
            </svg>
          </span>
          <span className="ml-10 ts-2xl">Carte </span>

        </div>
        <div className='map w-full pl-10 pr-10 text-center relative'>
          <table id="grid" className="m-auto my-10 table-fixed border-collapse border border-slate-400 relative">
            <img src="/alien.png" class="absolute" alt="" style={{ left: startX, top: startY }} />
            <tbody>
              {["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O"].map(lettre => (
                <tr>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map(nombre => (
                    <td
                      id={`${lettre}${nombre}`}
                      onClick={() => { selected(`${lettre}${nombre}`) }}
                      className={(selectedCell == `${lettre}${nombre}` ? "selected-cell " : undefined) +
                        (lettre == "A" || lettre == "H" || lettre == "O" || nombre == "1" || nombre == "8" || nombre == "15" ? " dark-cell " : " light-cell ") +
                        'cell border-collapse	border-collapse border   border-slate-400'} >{`${lettre}${nombre}`}</td>

                  ))}
                </tr>
              ))

              }
            </tbody>
          </table>
        </div>
      </div>

    </div>
  )
}